import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  id: "stylesContainer",
  class: "container-as-nav-item"
}
const _hoisted_3 = {
  key: 0,
  class: "pt-5"
}
const _hoisted_4 = { class: "category-browse__num" }
const _hoisted_5 = {
  key: 1,
  class: "text-gray-med"
}
const _hoisted_6 = { class: "category-browse__product-grid" }
const _hoisted_7 = ["id"]
const _hoisted_8 = { class: "pt-5" }
const _hoisted_9 = { class: "category-browse__num" }
const _hoisted_10 = {
  key: 0,
  class: "text-gray-med"
}
const _hoisted_11 = {
  key: 1,
  class: "text-gray-med"
}
const _hoisted_12 = { class: "category-browse__product-grid" }
const _hoisted_13 = {
  key: 2,
  id: "productsContainer",
  class: "container-as-nav-item"
}
const _hoisted_14 = { class: "category-browse__product-grid" }
const _hoisted_15 = {
  key: 0,
  class: "text-gray-med section-bottom-huge"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductItem = _resolveComponent("ProductItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.groupBy === `StylesFunctions`)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($props.styles, (style) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (style.title)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_3, [
                  _createTextVNode(_toDisplayString(style.title) + " ", 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_4, "(" + _toDisplayString($props.showWholesale ? $setup.filteredStyles(style.products).length : style.products.length) + ")", 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            ($props.showWholesale && !$setup.filteredStyles(style.products).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($props.translations.NoWholesaleProductsExist), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(($props.showWholesale ? $setup.filteredStyles(style.products) : style.products), (product, index) => {
                return (_openBlock(), _createBlock(_component_ProductItem, {
                  key: index,
                  displayName: product.displayName,
                  primaryImageUrl: product.algoliaVariantGrouping.primaryImageUrl,
                  alternateFinishes: product.availableFinishes,
                  availability: product.algoliaVariantGrouping.availability,
                  link: $setup.activeFinishUrl(product),
                  translations: $props.translations
                }, null, 8 /* PROPS */, ["displayName", "primaryImageUrl", "alternateFinishes", "availability", "link", "translations"]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      : ($props.groupBy === `Types` && $setup.store.state?.categorySlug !== `other-products`)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($props.productTypes, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", {
                id: item.type?.slug,
                class: "container-as-nav-item"
              }, [
                _createElementVNode("h3", _hoisted_8, [
                  _createTextVNode(_toDisplayString(item.type.name) + " ", 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_9, "(" + _toDisplayString($props.showWholesale ? $setup.filteredTypes(item.products).length : item.products.length) + ")", 1 /* TEXT */)
                ]),
                ($props.showWholesale && !$setup.filteredTypes(item.products).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($props.translations.NoWholesaleProductsExist), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (!$props.showWholesale && !item.products.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($props.translations.NoResultsAvailable), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(($props.showWholesale ? $setup.filteredTypes(item.products) : item.products), (product, index) => {
                    return (_openBlock(), _createBlock(_component_ProductItem, {
                      key: index,
                      displayName: product.displayName,
                      primaryImageUrl: product.algoliaVariantGrouping.primaryImageUrl,
                      alternateFinishes: product.availableFinishes,
                      availability: product.algoliaVariantGrouping.availability,
                      link: $setup.activeFinishUrl(product),
                      translations: $props.translations
                    }, null, 8 /* PROPS */, ["displayName", "primaryImageUrl", "alternateFinishes", "availability", "link", "translations"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ], 8 /* PROPS */, _hoisted_7)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              ($props.showWholesale && !$setup.filteredOthers($props.products).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString($props.translations.NoWholesaleProductsExist), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(($props.showWholesale ? $setup.filteredOthers($props.products) : $props.products), (product, index) => {
                return (_openBlock(), _createBlock(_component_ProductItem, {
                  key: index,
                  displayName: product.displayName,
                  primaryImageUrl: product.algoliaVariantGrouping.primaryImageUrl,
                  alternateFinishes: product.availableFinishes,
                  availability: product.algoliaVariantGrouping.availability,
                  link: $setup.activeFinishUrl(product),
                  translations: $props.translations
                }, null, 8 /* PROPS */, ["displayName", "primaryImageUrl", "alternateFinishes", "availability", "link", "translations"]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
  ]))
}